import { render, staticRenderFns } from "./nav2.vue?vue&type=template&id=bde141c4&scoped=true&"
import script from "./nav2.vue?vue&type=script&lang=js&"
export * from "./nav2.vue?vue&type=script&lang=js&"
import style0 from "./nav2.vue?vue&type=style&index=0&id=bde141c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde141c4",
  null
  
)

export default component.exports